import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=48df9489&"
import script from "./Calendar.vue?vue&type=script&lang=js&"
export * from "./Calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\06.04\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48df9489')) {
      api.createRecord('48df9489', component.options)
    } else {
      api.reload('48df9489', component.options)
    }
    module.hot.accept("./Calendar.vue?vue&type=template&id=48df9489&", function () {
      api.rerender('48df9489', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Tributos/ui/Calendar.vue"
export default component.exports